import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

class ImageCarouselItemPreview extends PureComponent {

  constructor(props) {
    super(props);
    this.handleItemClick = this.handleItemClick.bind(this);
  }

  handleItemClick(e) {
    e.preventDefault();
    this.props.onItemClick(this.props.image);
  }

  render() {
    const { image } = this.props;
    return (
      <li key={image.url} className={this.props.className + (this.props.isActive ? ' active' : '')}>
        <a onClick={this.handleItemClick} data-interaction={'pdp-image-selection'}>
          <img src={image.url} alt={'Product'} />
        </a>
      </li>
    );
  }
}

ImageCarouselItemPreview.propTypes = {
  image: PropTypes.shape({
    url: PropTypes.string.isRequired
  }).isRequired,
  onItemClick: PropTypes.func,
  isActive: PropTypes.bool,
  className: PropTypes.string
};

ImageCarouselItemPreview.defaultProps = {
  onItemClick: () => {},
  isActive: false,
  className: ''
};

export default ImageCarouselItemPreview;
